(function (window, $) {
  // const confirmEmitter = window.useEmitter();

  class Confirm extends DropDownProxy {
    constructor(options = {}) {
      const {
        title = "",
        content = "确认执行此操作？",
        confirmText = "确定",
        cancelText = "取消",
        onConfirm,
        onCancel,
        ...opt
      } = options;
      super(opt);

      DropDownProxy.confirmInstances.push(this);

      const $confirm = $(`<button class="confirm-button">${confirmText}</button>`);
      const $cancel = $(`<button class="cancel-button">${cancelText}</button>`);
      $confirm.on("click", (e) => {
        requestAnimationFrame(() => {
          typeof onConfirm === "function" && onConfirm();
          this.dropdownHide();
        });
      });
      $cancel.on("click", (e) => {
        requestAnimationFrame(() => {
          typeof onCancel === "function" && onCancel();
          this.dropdownHide();
        });
      });

      const $body = $('<div class="confirm-body">');

      if (title) {
        $body.append($('<div class="confirm-title">').text(title));
      }

      this.$html.append(
        $body.append(
          $('<div class="confirm-content">').text(content),
          $('<div class="confirm-footer">').append($cancel, $confirm),
        ),
      );

      this.emitter.on("toggleShow", (isShow) => {
        this.$input.data("isShowConfirm", isShow);
      });

      // document.addEventListener(
      //   "click",
      //   (e) => {
      //     if (!this.isShow) return;
      //     if (!this.$html.is(e.target) && this.$html.has(e.target).length === 0) {
      //       this.dropdownHide();
      //     }
      //   },
      //   true,
      // );
    }
  }

  window.Confirm = Confirm;

  $.fn.confirm = function (options = {}) {
    if ($(this).data("confirm")) return $(this);

    $(this).data(
      "confirm",
      new Confirm({
        selfOnly: true,
        placement: "bottom",
        $input: this,
        ...options,
      }),
    );

    return $(this);
  };
})(window, jQuery);
